// 9fbef606107a605d69c0edbcd8029e5d
const LOADER_CONSTANTS = {
  SET_LOADER_STATE: 'SET_LOADER_STATE',
  SET_ATB_API_CALL_STATUS: 'SET_ATB_API_CALL_STATUS',
  SET_LOYALTY_API_CALL_STATUS: 'SET_LOYALTY_API_CALL_STATUS',
  OPEN_PAGE_SPINNER: 'OPEN_PAGE_SPINNER',
  CLOSE_PAGE_SPINNER: 'CLOSE_PAGE_SPINNER',
  SET_SECTION_LOADER_STATE: 'SET_SECTION_LOADER_STATE',
  SET_EXTERNAL_CAMPAIGN_STATE: 'SET_EXTERNAL_CAMPAIGN_STATE',
  SET_GHOST_LOADER_STATE: 'SET_GHOST_LOADER_STATE',
  SET_GHOST_LOADER_STATE_COMPLETE: 'SET_GHOST_LOADER_STATE_COMPLETE',
  SET_LOADER_QUICK_VIEW: 'SET_LOADER_QUICK_VIEW',
  LOGOUT_IN_PROGRESS: 'LOGOUT_IN_PROGRESS',
  SET_ATB_API_CALL_MAINTENANCE_STATUS: 'SET_ATB_API_CALL_MAINTENANCE_STATUS',
};
export default LOADER_CONSTANTS;
